import React from 'react';
import PropTypes from 'prop-types';
/* Helpers */
import {getClassName} from '../../../helpers/dom-helpers';
/* styles */
import './icon-button.scss';

class IconButton extends React.PureComponent {
  render() {
    const iconButtonClass = getClassName('glu-icon-button', this.props.className, {
      'glu-icon-button--disabled': this.props.isDisabled,
    });
    const iconClass = `glu-icon-button__icon g-icon g-icon-${this.props.icon}`;
    return (
      <div
        className={iconButtonClass}
        onClick={!this.props.isDisabled ? this.props.onClick : undefined}
      >
        <div className={iconClass} />
        <div className="glu-icon-button__item">
          {this.props.children ? this.props.children : this.props.text}
        </div>
      </div>
    );
  }
}

IconButton.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
  icon: PropTypes.string,
};

IconButton.defaultProps = {
  text: '',
  className: '',
  onClick: undefined,
  isDisabled: false,
  children: null,
  icon: '',
};

export default IconButton;
